import React, { useState } from 'react';
import { Button, Flex, Popover, Text } from 'core/components';
import { observer } from 'mobx-react';
import { Position } from '@blueprintjs/core';
import Table from 'core/components/HTMLTable';

function valueToString(value) {
  if (value === null || value === undefined) {
    return 'null';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}

const JsonTableRenderer = ({ value = '' }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // Handle undefined, null, or empty values
  if (!value || value === '') {
    return <Text>--</Text>;
  }

  let parsedValue;
  try {
    parsedValue = JSON.parse(value);
    if (typeof parsedValue !== 'object' || parsedValue === null) {
      return <Text>{String(value)}</Text>;
    }
  } catch (error) {
    // If parsing fails, display the raw value
    return <Text>{String(value)}</Text>;
  }

  const entries = Object.entries(parsedValue).sort(([a], [b]) => a.localeCompare(b));

  return (
    <Flex alignItems="center" gap={1}>
      <Popover
        minimal={false}
        position={Position.LEFT}
        isOpen={isPopoverOpen}
        onInteraction={(nextOpenState) => setIsPopoverOpen(nextOpenState)}
        onClose={() => setIsPopoverOpen(false)}
        usePortal
        content={
          <Table striped bordered condensed>
            <thead>
              <tr>
                <th>Key</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {entries.map(([k, v]) => (
                <tr key={k}>
                  <td>{k}</td>
                  <td>{valueToString(v)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        }
      >
        <Flex alignItems="center" gap={1}>
          <Button small minimal icon="maximize" onClick={() => setIsPopoverOpen(!isPopoverOpen)} />
        </Flex>
      </Popover>
      <Text ellipsis>{entries.map(([k, v]) => `${k}=${JSON.stringify(v)}`).join(', ')}</Text>
    </Flex>
  );
};

export default observer(JsonTableRenderer);
